import type { LocationService } from "@agrigate/location-management-api/lib/services/LocationService";
import * as RepAPI from "@agrigate/reporting-api/lib/clients";
import * as PrimaryAPI from "@agrigate/rpc-clients";
import type { RPCMeta } from "@agrigate/shared/lib/rpc/clients";
import type { MaybeP } from "@agrigate/ts-utils/lib/types";
import { fn } from "overridable-fn";

export const getHeaders = fn.memo((): MaybeP<Record<string, string>> => ({}));

export const handleError = fn.memo(
    (_method: string, _params: unknown[], _meta?: RPCMeta, error?: unknown) => {
        console.error("RPC Error:", error);
    },
);

declare const API_BASE: string;
declare const API_GW_BASE: string;
declare const USE_BACKEND_REP_API: string;

const useLocalRepAPI = USE_BACKEND_REP_API === "true";

export const rpc: {
    reporting: RepAPI.Clients;
    primary: PrimaryAPI.Clients;
} = {
    reporting: RepAPI.getClients(
        {
            url: useLocalRepAPI ? API_BASE : API_GW_BASE,
            getHeaders,
        },
        useLocalRepAPI ? "backend" : "gateway",
        {
            onError: handleError,
        },
    ),
    primary: PrimaryAPI.getClients(
        {
            backend: { url: API_BASE, getHeaders },
            gateway: { url: API_GW_BASE, getHeaders },
        },
        {
            onError: handleError,
        },
    ),
};

export const getLocationService = fn.memo((): LocationService => {
    throw new Error("Override in consumer");
});
